module.exports = __webpack_public_path__ + "img/35.b144e10e.jpg";